import type { RouteRecordRaw } from 'vue-router';
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth';
import { allPlanRoutes } from '@/pages/plan/routes';

export const planRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.package_plan, action: PermissionAction.enum.view },
  },
  children: [
    ...allPlanRoutes,
  ],
};
